<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'Doc::CustomerInvoice:CreateSubscription' | abpLocalization }}
  </h4>
</div>
<div class="modal-body">
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="row row-cols-1 row-cols-md-4 my-2">
        <div class="col col-md-4">
          <label for="dayBookId" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::DayBook' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="dayBookId"
            formControlName="dayBookId"
            bindLabel="name.current"
            bindValue="id"
            [items]="dayBooks"
          >
          </ng-select>
        </div>
        <div class="col col-md-4">
          <label for="reference" class="form-label text-primary">
            {{ 'Doc::CustomerReference' | abpLocalization }}
          </label>
          <input type="text" class="form-control" formControlName="reference" />
        </div>
        <div class="col col-md-4">
          <label for="startDate" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::CustomerSubscription:StartDate' | abpLocalization }}
          </label>
          <dw-core-date-picker formControlName="startDate"></dw-core-date-picker>
        </div>
      </div>

      <div class="row row-cols-1 row-cols-md-4 my-2">
        <div class="col col-md-4">
          <label for="frequency" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::SubscriptionFrequency' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="frequency"
            formControlName="frequency"
            bindLabel="name.current"
            bindValue="id"
            [loading]="enumerationTypeStore.loading()"
            [items]="enumerationTypeStore.subscriptionFrequencies()"
          >
          </ng-select>
        </div>
        <div class="col col-md-4">
          <label for="billingMethod" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::SubscriptionBillingMethod' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="billingMethod"
            formControlName="billingMethod"
            bindLabel="name.current"
            bindValue="id"
            [loading]="enumerationTypeStore.loading()"
            [items]="enumerationTypeStore.billingMethods()"
          >
          </ng-select>
        </div>
        <div class="col col-md-4">
          <label
            for="billingMode"
            class="form-label text-primary"
            [dwInputRequired]="this.form?.get('billingMethod')?.value == BillingMethods.Auto"
          >
            {{ 'Doc::SubscriptionBillingMode' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="billingMode"
            formControlName="billingMode"
            bindLabel="name.current"
            bindValue="id"
            [loading]="enumerationTypeStore.loading()"
            [items]="enumerationTypeStore.billingModes()"
          >
          </ng-select>
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary ms-2" (click)="modal.close()">
    {{ 'ERP::Cancel' | abpLocalization }}
  </button>
  <button class="btn btn-primary ms-2" (click)="save()">{{ '::Save' | abpLocalization }}</button>
</div>
